import { render, staticRenderFns } from "./PresentPhotoVirtual.vue?vue&type=template&id=1163872a&scoped=true&"
import script from "./PresentPhotoVirtual.vue?vue&type=script&lang=js&"
export * from "./PresentPhotoVirtual.vue?vue&type=script&lang=js&"
import style0 from "./PresentPhotoVirtual.vue?vue&type=style&index=0&id=1163872a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163872a",
  null
  
)

export default component.exports